module KendoWidgets
{
	export class CheckBoxListClickEvent
	{
		sender: CheckBoxElement;
		checked: boolean;
		value: string;
		text: string;
		label: KendoWidgets.Label;
	}

	export class CheckBoxListOptions
	{
		checkboxList: CheckBoxItem[];
		orientation?: KendoWidgets.OrientationEnum;
		label?: string;
		width?: string | number;
		css?: string;
		allChecked?: boolean;

		check?(e: KendoWidgets.CheckBoxListClickEvent): void;
	}

	export class CheckBoxList extends kendo.ui.Widget implements KendoWidget
	{
		private _selectedList: CheckBoxElement[] | null;
		public controlType(): ControlTypeEnum { return ControlTypeEnum.CheckBoxList; }

		constructor(element: Element, options?: KendoWidgets.CheckBoxListOptions)
		{
			if (options == null)
				options = new KendoWidgets.CheckBoxListOptions();

			if (options.allChecked == null) options.allChecked = false;

			//#region Width
			if (options.width == null)
				options.width = "auto";

			if (typeof (options.width) == "number")
			{
				options.width = options.width + "px";
				$(element).css("display", "inline-block");
			}
			$(element).width(options.width);
			//#endregion

			//#region CSS
			if (options.css != null)
				(element as HTMLElement).style.cssText += options.css;
			//#endregion

			if (options.orientation == null) options.orientation = OrientationEnum.Horizontal;

			super(element, options);
			let that = this;

			//#region List creation
			if (options.checkboxList != null)
			{
				this._selectedList = [];
				let i = 0;
				for (let checkBoxItem of options.checkboxList)
				{
					//#region Checkbox
					let input = document.createElement("input");
					input.classList.add("k-checkbox");
					$(input).attr("type", "checkbox");
					$(input).attr("name", element.id + "Name");
					$(input).attr("id", element.id + "Checkbox" + i);
					$(input).attr("value", checkBoxItem.value);
					//#endregion

					//#region Label
					$("#" + input.id + "Label").remove();
					let label = document.createElement("label");
					label.id = input.id + "Label";
					$(label).attr("for", input.id);
					let kendoLabel = $(label).kendoLabel(
						{
							text: checkBoxItem.text,
							class: "k-checkbox-label"
						}).data("kendoLabel");
					//#endregion

					//#region Orientation
					if (options!.orientation == OrientationEnum.Horizontal && i > 0)
						label.style.cssText += "margin-left: 10px;";
					else if (options!.orientation == OrientationEnum.Vertical)
						label.style.cssText += "width: Calc(100% - 27px);";
					//#endregion

					//#region Checked values
					if (checkBoxItem.checked == true)
					{
						input.checked = true;

						let checkBox = new CheckBoxElement();
						checkBox.element = input;
						checkBox.value = String(checkBoxItem.value);
						checkBox.text = checkBoxItem.text;
						checkBox.label = kendoLabel;

						that._selectedList!.push(checkBox);
					}
					//#endregion

					//#region All checked
					if (options!.allChecked == true)
						input.checked = true;
					//#endregion

					//#region Check event
					let checkUserOverride = options!.check;
					$(input).click((e: KendoWidgets.CheckBoxListClickEvent) =>
					{
						// Create radio button
						let checkBox = new CheckBoxElement();
						checkBox.element = input;
						checkBox.value = String(checkBoxItem.value);
						checkBox.text = checkBoxItem.text;
						checkBox.label = kendoLabel;

						if (!(e as any).currentTarget.checked)
							that.unChecked([String(checkBoxItem.value)]);
						else
							that.checked([String(checkBoxItem.value)]);

						// Create event
						e.sender = checkBox;
						e.checked = input.checked;
						e.value = String(checkBoxItem.value);
						e.text = checkBoxItem.text;
						e.label = kendoLabel;

						if (checkUserOverride != null)
							checkUserOverride(e);

						that.validate();
					});
					//#endregion

					element.appendChild(input);
					$(input).after(label);
					i++;
				}

				$("#" + element.id + "RequiredValues").remove();
				$(element).append("<label id='" + element.id + "RequiredValues' class='checkboxListRequiredLabel'>(*) Campi obbligatori</label>");
			}
			//#endregion

			//#region Label
			if (options.label != null && options.label.length > 0)
			{
				$("#" + element.id + "Label").remove();
				let label = document.createElement("label");
				label.id = element.id + "Label";
				$(label).kendoLabel(
					{
						text: options.label,
						color: KendoWidgets.ColorEnum.BlueVettore,
						fontSize: 14,
						height: 19
					});

				$(element).prepend(label);
			}
			//#endregion

			window.setTimeout(() => that.validate());
		}

		clear(checkAll?: boolean)
		{
			if (checkAll == true)
				this.checkAll();
			else
				this.unChecked((this.options as KendoWidgets.CheckBoxListOptions).checkboxList.map(k => String(k.value)));
		}

		checkAll()
		{
			this.checked((this.options as KendoWidgets.CheckBoxListOptions).checkboxList.map(k => String(k.value)));
		}

		checked(values?: string[])
		{
			if (values != null)
			{
				for (let value of values)
				{
					let checkBox = this.getCheckBoxByValue(value);
					if (checkBox != null)
					{
						checkBox.element.checked = true;
						if (!this._selectedList!.map(k => k.value).includes(value))
							this._selectedList!.push(checkBox);
					}
				}
			}

			return this._selectedList;
		}

		checkedValues()
		{
			return this.checked()!.map(k => k.value);
		}

		isChecked(value: string)
		{
			return this.checkedValues().includes(value);
		}

		isRequired(value: string)
		{
			return (this.options as KendoWidgets.CheckBoxListOptions).checkboxList.filter(k => k.required == true).map(k => String(k.value)).includes(value);
		}		

		requiredValues()
		{
			return (this.options as KendoWidgets.CheckBoxListOptions).checkboxList.filter(k => k.required == true).map(k => String(k.value));
		}

		getItems()
		{
			let items: CheckBoxElement[] = [];
			for (let value of (this.options as KendoWidgets.CheckBoxListOptions).checkboxList.map(k => String(k.value)))
			{
				let checkBox = this.getCheckBoxByValue(value);
				if (checkBox != null)
					items.push(checkBox);
			}
			return items;
		}

		validate()
		{
			let isValid = true;
			let requiredValues = this.requiredValues();
			if (requiredValues.length > 0)
			{
				$("#" + (this.element.attr("id") + "RequiredValues")).show();
				for (let requiredValue of requiredValues)
				{
					let checkbox = this.getCheckBoxByValue(requiredValue);
					if (checkbox != null)
					{
						let text = $("#" + checkbox.element.id + "Label").html();
						if (!text.endsWith(" (*)"))
							$("#" + checkbox.element.id + "Label").html($("#" + checkbox.element.id + "Label").html() + " (*)");

						if (!checkbox.element.checked)
						{
							$("#" + checkbox.element.id + "Label").css("background-color", "#ffe9e9");
							isValid = false;
						}
						else
							$("#" + checkbox.element.id + "Label").css("background", "none");
					}
				}
			}
			else
				$("#" + (this.element.attr("id") + "RequiredValues")).hide();

			return isValid;
		}

		unChecked(values?: string[])
		{
			if (values != null)
			{
				for (let value of values)
				{
					let checkBox = this.getCheckBoxByValue(value);
					if (checkBox != null)
					{
						checkBox.element.checked = false;
						if (this._selectedList!.map(k => k.value).includes(value))
						{
							let index = this._selectedList!.findIndex(k => k.value == value);
							this._selectedList!.splice(index, 1);
						}
					}
				}
			}

			return this._selectedList;
		}

		private getCheckBoxByValue(value: string)
		{
			// Input button
			let inputButton = this.element.find("[value=" + value + "]")[0] as HTMLInputElement;
			let inputButtonLabel: HTMLLabelElement;
			if (inputButton != null)
			{
				// Label
				inputButtonLabel = this.element.find("#" + inputButton.id + "Label")[0] as HTMLLabelElement;
				let kendoLabel = $(inputButtonLabel).data("kendoLabel");

				// Create checkBox
				let checkBox = new CheckBoxElement();
				checkBox.element = inputButton;
				checkBox.value = value;
				checkBox.text = (kendoLabel != null) ? kendoLabel.text() : "";
				checkBox.label = kendoLabel;
				checkBox.checked = this.isChecked(value);
				checkBox.required = this.isRequired(value);
				return checkBox;
			}
			else
				return null;
		}

		appendTo(element: string | HTMLElement | JQuery)
		{
			this.element.appendTo(element);
		}

		prependTo(element: string | HTMLElement | JQuery)
		{
			this.element.prependTo(element);
		}
	}

	CheckBoxList.fn = CheckBoxList.prototype;
	CheckBoxList.fn.options = $.extend(true, {}, kendo.ui.Widget.fn.options);
	CheckBoxList.fn.options.name = "CheckBoxList";
	kendo.ui.plugin(CheckBoxList);

	export class CheckBoxElement
	{
		public element: HTMLInputElement;
		public value: string;
		public text: string;
		public required: boolean;
		public checked: boolean;
		public label: KendoWidgets.Label;
	}

	export class CheckBoxItem
	{
		public text: string;
		public value: string | number;
		public required?: boolean;
		public checked?: boolean;
	}

	export enum CheckBoxLabelPositionEnum
	{
		Left,
		Right
	}
}

interface JQuery
{
	kendoCheckBoxList(options?: KendoWidgets.CheckBoxListOptions): JQuery;
	data(key: "kendoCheckBoxList"): KendoWidgets.CheckBoxList;
}